export default "__VITE_ASSET__Cl4fu3ae__"